import axios from 'axios';
import { endpoint, headers } from '@app/utils/service';
import { FetchPermission } from '@app/typings/services/permission';

export const fetchBrandPermission: FetchPermission = () => {
  return axios({
    url: endpoint('/permissions'),
    params: {
      levels: 'brand',
    },
    method: 'GET',
    ...headers(),
  });
};

export const fetchProjectPermission: FetchPermission = () => {
  return axios({
    url: endpoint('/permissions'),
    params: {
      levels: 'project,group',
    },
    method: 'GET',
    ...headers(),
  });
};
